import { ManageERAActionTypes } from "../constants/ApiConstants";

const initialState = {
    all_ERA_Claims: {},
    loading: false,
    all_EDI_GATEWAYS: null

};


export default (state = initialState, { type, payload }) => {
    switch (type) {
        case ManageERAActionTypes.get_All_ERA_Claims.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case ManageERAActionTypes.get_All_ERA_Claims.SUCCESS:
            return {
                ...state,
                loading: false,
                all_ERA_Claims: payload
            }

        case ManageERAActionTypes.get_EDI_GateWays.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case ManageERAActionTypes.get_EDI_GateWays.SUCCESS:
            return {
                ...state,
                loading: false,
                all_EDI_GATEWAYS: payload
            }
        case ManageERAActionTypes.get_EDI835_File.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case ManageERAActionTypes.get_EDI835_File.SUCCESS:
            return {
                ...state,
                loading: false,
            }
        case ManageERAActionTypes.bULK_DOWNLOAD_ERA_DETAILS.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case ManageERAActionTypes.bULK_DOWNLOAD_ERA_DETAILS.SUCCESS:
            return {
                ...state,
                loading: false,
            }    
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/ManageERA/reducers/ManageERAReducers.js